import React from 'react';
import { compose, is } from 'ramda';

import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import validateAsyncComponent from '@synergycms_core/components/HoC/validateAsyncComponent';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import styleFile from './AvailMainSideSummaryHotel.js';
import { RichText } from '@synergycms_core/components/generic';
import Stars from '../../Stars';
import { Map } from 'immutable';
import connect from 'react-redux/es/connect/connect';
import { withContent } from '@synergycms_core/components/providers/translateProvider';
import { contextualizeAppConfig } from '@synergycms_core/store/app/utils';
import AvailSummarySendMail from '../AvailSummarySendMail';

const AvailMainSideSummaryHotel = class AvailMainSideSummaryHotel extends React.Component {
  static displayName = 'AvailMainSideSummaryHotel';

  render() {
    const { config, theme } = this.props,
      {
        hotel,
        hotelConfig,
        stepCode,
        totalAdults,
        totalChilds
      } = config;

    const { classes } = theme.styles;

    const showSendMailForm =  hotelConfig.get("show_avail_selection") || '';
    const categoryType = hotel.get('category_type', 'default');

    return (
      <div className={[classes.contentHotelInfo, classes.first].join(' ')}>
        <div>
          <Stars stars={hotel.get('stars')} categoryType={categoryType} innerStyle={'starPromotions'} />
          <RichText innerStyle={classes.hotelTitle}>{hotel.get('name')}</RichText>
          <RichText innerStyle={classes.hotelAdress}>
            {hotel.get('address')} {hotel.get('city')} {hotel.get('zip_code')}, {hotel.get('country')}
          </RichText>
        </div>
        {showSendMailForm.split(';').includes(stepCode) && (
          <AvailSummarySendMail hotelId={hotel.get('id')} totalAdults={totalAdults} totalChilds={totalChilds}/>
        )}
      </div>
    );
  }
};

const mapDispatchToProps = dispatch => {
  return {};
};

const mapStateToProps = (store, ownProps) => {
  const hotelId = store.getIn(['customer', 'current_hotel']);
  const hotelInfo = store.getIn(['hotels', hotelId]);
  const stepCode = store.getIn(['customer', 'step', 'current_step', 'code']);
  
  return {
    hotel: is(Map, hotelInfo) && hotelInfo.size > 0 && hotelInfo.get('name') && hotelInfo,
    hotelConfig : contextualizeAppConfig(store, hotelId),
    stepCode: stepCode,
  };
};

export default compose(
  validateAsyncComponent(mapStateToProps),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  PropertyManager([
    'hotel',
    'hotelConfig',
    'stepCode',
    'totalAdults',
    'totalChilds',
  ]),
  withThemeJSS({ styleFile, link: true }),
  withContent('i18n')
)(AvailMainSideSummaryHotel);
